export default __webpack_public_path__ + "static/media/class.5456c0e7.svg";